<template>
  <router-link tag="div" :to="{name:'exam',params: {slug: exam.slug}}" class="exam-item bg-block"
               style="margin-bottom: 20px">
    <div class="bg"></div>
    <div class="content">{{ exam.title }}</div>
  </router-link>
</template>

<script>
export default {
  props: ['exam']
}
</script>

<style lang="scss" scoped>
.exam-item{
  .content{
    border-left: 6px solid $green;
    font-weight: 600;
  }
}
</style>
